export default __webpack_public_path__ + "static/media/image-095.3de025ab.jpg";